import { useEffect, useRef, useState } from "react";
import { dto_cart_checkout } from "../../../../classes/dto-cart-checkout";
import { WebWidth } from "../../../../config/config";
import { isMobile } from "react-device-detect";
import { Colors } from "../../../../util/colors";

function truncateText(text, maxLength) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
}

function Popup({ initialNote = "", onClose }) {
  const [note, setNote] = useState(initialNote);
  const inputRef = useRef(null);

  useEffect(() => {
    setNote(initialNote);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [initialNote]);

  const handleSave = () => {
    onClose(note);
  };

  const handleClear = () => {
    setNote("");
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div
      style={{
        width: isMobile ? "100%" : `${WebWidth}px`,
        position: "fixed",
        marginBottom: -55,
        left: "50%",
        height: "135px",
        transform: "translate(-50%, -50%)",
        backgroundColor: "white",
        padding: "20px",
        zIndex: 100,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        style={{ position: "relative", display: "flex", alignItems: "center" }}
      >
        <input
          type="text"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          style={{
            border: "1px solid #ccc",
            outline: "none",
            width: "100%",
            height: "40px",
            paddingRight: "30px",
            paddingLeft: "10px",
          }}
          maxLength={250}
          placeholder="Write your note here"
          ref={inputRef}
        />
        {note && (
          <i
            className="bi bi-x-circle"
            onClick={handleClear}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#ccc",
            }}
          />
        )}
      </div>
      <div
        onClick={handleSave}
        style={{
          marginTop: "10px",
          width: "100%",
          paddingTop: "10px",
          paddingBottom: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundColor: Colors.DarkGreyScale,
          cursor: "pointer",
        }}
      >
        Add
      </div>
    </div>
  );
}

function NoteBox() {
  const [showPopup, setShowPopup] = useState(false);
  const [note, setNote] = useState(dto_cart_checkout?.Comment || "");
  const togglePopup = () => setShowPopup(true);

  const handleClose = (newNote) => {
    // Only update if newNote is not undefined
    if (newNote !== undefined) {
      setNote(newNote);
      dto_cart_checkout.Comment = newNote;
    }
    setShowPopup(false);
  };

  useEffect(() => {
    if (dto_cart_checkout?.Comment) {
      setNote(dto_cart_checkout.Comment);
    }
  }, []);

  return (
    <div
      style={{
        padding: "10px 20px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <div style={{ flexShrink: 0 }}>
        <i className="bi bi-journal-text" style={{ fontSize: "24px" }} />
      </div>
      <div
        id="productNote"
        style={{
          flexGrow: 1,
          height: "40px",
          display: "flex",
          alignItems: "center",
          padding: "0 10px",
          cursor: "pointer",
          fontWeight: 'bold'
        }}
        onClick={togglePopup}
      >
        {note ? truncateText(note, 28) : "Add Note"}
      </div>
      <div style={{ flexShrink: 0 }} onClick={togglePopup}>
        <i
          className="bi bi-caret-right-fill"
          style={{ fontSize: "18px", cursor: "pointer" }}
        />
      </div>
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99,
          }}
          onClick={() => handleClose(note)}
        >
          <Popup initialNote={note} onClose={handleClose} />
        </div>
      )}
    </div>
  );
}

export default NoteBox;
